<div class="wrapper" [ngClass]="type()" #ele>
  @if(icon()){
  <div class="icon">
    <icon [name]="icon()" />
  </div>
  }
  <p class="label ellipsis">{{label()|translate}}</p>
</div>
